module.exports = __webpack_public_path__ + "aa6c276c905a256802e1ccf992d78bd6.svg";